<template>

  <div class="app-container">

    <el-form label-width="120px">
      <el-form-item label="下载模板">
        <a href="https://linggan-1316937351.cos.ap-shanghai.myqcloud.com/jdorder-template.xlsx">订单批量导入模板.xlsx</a>
      </el-form-item>
      <el-form-item label="选择Excel">
        <el-upload
          ref="dragupload"
          :auto-upload="false"
          :on-success="fileUploadSuccess"
          :on-error="fileUploadError"
          :disabled="importBtnDisabled"
          :limit="1"
          :headers="mytoken"
          :action="'/api/jdOrder/export'"
          :data="uploadData"
          :on-remove="handleRemove"
          name="file"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
          >选取文件</el-button>
          <el-button
            :loading="loading"
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submitUpload"
          >麦炫订单导出</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>

</template>
  
  <script>
export default {
  data() {
    //定义变量和初始值
    return {
      importBtnDisabled: false, // 按钮是否禁用,
      loading: false
    };
  },
  computed: {
    mytoken() {
      return {
        "x-auth-token": localStorage.getItem("token")
      };
    },
    uploadData() {
      return {};
    },
    uploadLgData() {
      return {};
    }
  },
  created() {
    //页面渲染之前执行
  },
  methods: {
    //点击按钮上传文件到接口里面
    submitUpload() {
      this.importBtnDisabled = true;
      this.loading = true;
      this.$refs.dragupload.submit();
    },
    //上传成功
    fileUploadSuccess(response) {
      console.log(response);
      //提示信息
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "success",
        message: "上传成功"
      });
      if (response.code === 1000) {
        const link = document.createElement("a");
        link.href = response.data;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$message({
          message: response.msg,
          type: "warning"
        });
      }
    },
    //上传失败
    fileUploadError() {
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "error",
        message: "失败"
      });
    }
  }
};
</script>
  
  
